import * as styles from "library/components/Footer/Footer.module.scss";
import { ReactComponent as IOMLogo } from "assets/logos/iom.svg";
import { ReactComponent as GamCare } from "assets/logos/gamcare.svg";

import React from "react";

const IsleOfManFooterContent = () => (
  <>
    <p>
      Felix Operations Limited is a company incorporated in the Isle of Man with
      registration number 022004V, having its registered address at Third Floor,
      34 Hope Street, Douglas, Isle of Man, IM1 1AP.
    </p>
    <p>
      Felix Operations Limited is licensed and regulated by the Isle of Man
      Gambling Supervision Commission, and the holder of an OGRA licence issued
      on the 7<sup>th</sup> of April 2025.
    </p>
    <p>
      All gambling debts are enforceable in Isle of Man courts. 18+, gamble
      responsibly.
    </p>
    <div className={styles.IOMLogos}>
      <a
        href="https://www.isleofmangsc.com/gambling/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IOMLogo width={"3.7rem"} height={"3rem"} />
      </a>
      <a
        href="https://www.gamcare.org.uk/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <GamCare width={"7rem"} height={"2rem"} />
      </a>
    </div>
  </>
);

export default IsleOfManFooterContent;
